"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaAccountBalanceRequestToJSON = exports.RosettaAccountBalanceRequestFromJSONTyped = exports.RosettaAccountBalanceRequestFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaAccountBalanceRequestFromJSON(json) {
    return RosettaAccountBalanceRequestFromJSONTyped(json, false);
}
exports.RosettaAccountBalanceRequestFromJSON = RosettaAccountBalanceRequestFromJSON;
function RosettaAccountBalanceRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network_identifier': _1.NetworkIdentifierFromJSON(json['network_identifier']),
        'account_identifier': _1.RosettaAccountFromJSON(json['account_identifier']),
        'block_identifier': !runtime_1.exists(json, 'block_identifier') ? undefined : json['block_identifier'],
    };
}
exports.RosettaAccountBalanceRequestFromJSONTyped = RosettaAccountBalanceRequestFromJSONTyped;
function RosettaAccountBalanceRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network_identifier': _1.NetworkIdentifierToJSON(value.network_identifier),
        'account_identifier': _1.RosettaAccountToJSON(value.account_identifier),
        'block_identifier': value.block_identifier,
    };
}
exports.RosettaAccountBalanceRequestToJSON = RosettaAccountBalanceRequestToJSON;
//# sourceMappingURL=RosettaAccountBalanceRequest.js.map